import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';

const Messages = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [email, setEmail] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchEmail();
  }, [id]);

  const fetchEmail = async () => {
    try {
      const response = await axios.get(`/api/emails/${id}`);
      setEmail(response.data);
    } catch (err) {
      console.error('Failed to fetch email:', err);
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async () => {
    if (!window.confirm('Delete this email?')) return;
    try {
      await axios.delete(`/api/emails/${id}`);
      navigate('/inbox');
    } catch (err) {
      alert('Failed to delete email');
    }
  };

  if (loading) return <div style={{ padding: '50px', textAlign: 'center' }}>Loading...</div>;
  if (!email) return <div style={{ padding: '50px', textAlign: 'center' }}>Email not found</div>;

  return (
    <div className="fade-in">
      <div style={{ marginBottom: '24px' }}>
        <button className="btn btn-ghost" onClick={() => navigate('/inbox')}>
          ← Back to Inbox
        </button>
      </div>

      <div className="card">
        <div style={{ 
          display: 'flex', 
          justifyContent: 'space-between', 
          alignItems: 'flex-start',
          marginBottom: '20px',
          paddingBottom: '20px',
          borderBottom: '1px solid var(--border)'
        }}>
          <div>
            <h1 style={{ fontSize: '24px', marginBottom: '8px' }}>
              {email.subject || '(No subject)'}
            </h1>
            <div style={{ color: 'var(--text-muted)', fontSize: '14px' }}>
              <div>From: {email.sender}</div>
              <div>To: {email.recipient}</div>
              <div>Date: {new Date(email.created_at || email.received_at).toLocaleString()}</div>
            </div>
          </div>
          <button className="btn btn-danger" onClick={handleDelete}>
            🗑️ Delete
          </button>
        </div>

        <div style={{ lineHeight: '1.8', whiteSpace: 'pre-wrap' }}>
          {email.body_text || email.body_html || email.body || 'No content'}
        </div>
      </div>
    </div>
  );
};

export default Messages;

